import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  border: none;
  padding: 0px;
`;

export const Content = styled.div`
  width: 100%;
  padding: 6px;
  margin-left: auto;
  margin-right: 0;
`;
